if (!customElements.get('jupityr-journal-grid')) {
  customElements.define('jupityr-journal-grid', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.cards = Array.from(this.querySelectorAll('[data-journal-card]'));
      this.buttons = Array.from(this.querySelectorAll('[data-journal-page]'));
      this.pageSize = Number(this.dataset.pageSize) || 9;
      this.total = Math.max(1, Math.ceil(this.cards.length / this.pageSize));
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-journal-page]');
        if (!button || !this.contains(button)) return;
        const next = Number(button.dataset.journalPage);
        if (next === this.page) return;
        this.showPage(next, true);
        const url = new URL(window.location.href);
        if (next === 1) url.searchParams.delete('journal_page');
        else url.searchParams.set('journal_page', String(next));
        window.history.pushState(null, '', url);
      }, options);
      window.addEventListener('popstate', () => this.showPage(this.pageFromUrl()), options);
      document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-journal-card]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.showPage(Math.floor(index / this.pageSize) + 1);
      }, options);
      this.showPage(this.pageFromUrl());
      const navigation = this.querySelector('.jupityr-journal__pagination');
      if (navigation) navigation.hidden = this.total < 2;
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    pageFromUrl() {
      const page = Number(new URL(window.location.href).searchParams.get('journal_page'));
      return Number.isInteger(page) && page > 0 ? Math.min(page, this.total) : 1;
    }

    showPage(value, moveFocus = false) {
      this.page = Math.max(1, Math.min(this.total, value));
      const start = (this.page - 1) * this.pageSize;
      this.cards.forEach((card, index) => {
        card.hidden = index < start || index >= start + this.pageSize;
      });
      this.buttons.forEach(button => {
        if (Number(button.dataset.journalPage) === this.page) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
      });
      const status = this.querySelector('[data-journal-status]');
      if (status) status.textContent = status.dataset.template.replace('[current]', this.page).replace('[total]', this.total);
      if (moveFocus) {
        const heading = this.querySelector('.jupityr-journal__header');
        heading?.focus({ preventScroll: true });
        heading?.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }
  });
}
